import React from 'react';

const Footer = () => {
    return (
        <div style={{ background: "#2B3443", padding: "15px 0px" }}>
            <div className="container">
                <p className="text-center text-secondary pt-2">Designed & Built by Motiur Rahman</p>
            </div>
        </div>
    );
};

export default Footer;